import { type CarouselSettings } from "@/components/common/Carousel";
import { SiteBuilderMultiColumnModuleRotation } from "@/constants/site-builder";
import { GridBreakpoint } from "@/constants/style";

const baseSettings: CarouselSettings = {
  spaceBetween: 24, // 1.5rem
  navigation: true,
  pagination: {
    type: "bullets",
    clickable: true,
  },
  speed: 1000,
};

export function getRotationSettings(
  rotation: SiteBuilderMultiColumnModuleRotation,
  columnsCount: number,
): CarouselSettings {
  switch (rotation) {
    case SiteBuilderMultiColumnModuleRotation.Static:
      return {
        ...baseSettings,
        breakpoints: {
          [GridBreakpoint.sm]: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          [GridBreakpoint.lg]: {
            slidesPerView: columnsCount,
            slidesPerGroup: columnsCount,
          },
        },
      };

    case SiteBuilderMultiColumnModuleRotation.Single:
      return {
        ...baseSettings,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      };

    case SiteBuilderMultiColumnModuleRotation.Page:
      return {
        ...baseSettings,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        breakpoints: {
          [GridBreakpoint.sm]: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          [GridBreakpoint.lg]: {
            slidesPerView: columnsCount,
            slidesPerGroup: columnsCount,
          },
        },
      };

    case SiteBuilderMultiColumnModuleRotation.Smooth:
      return {
        ...baseSettings,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 4000,
        navigation: false,
        pagination: false,
      };

    default:
      return baseSettings;
  }
}
